import { createQueryKeys } from "@lukemorales/query-key-factory";

import {
  getOrganization,
  listOrganizationInvitations,
  listOrganizationProviders,
  listOrganizations,
  listOrganizationSeats,
} from "~/admins/api";
import {
  OrganizationFilters,
  OrganizationInvitationsFilters,
  OrganizationSeatFilters,
} from "~/admins/types/organization";

export const organizationQueryOptionsFactory = createQueryKeys(
  "organizations",
  {
    detail: (id: string) => ({
      queryKey: [id],
      queryFn: () => getOrganization(id),
      contextQueries: {
        seats: (filters: OrganizationSeatFilters) => ({
          queryKey: [{ filters }],
          queryFn: ({ queryKey: [_base, _detail, id] }) =>
            listOrganizationSeats(id as string, filters),
        }),
        invitations: (filters: OrganizationInvitationsFilters) => ({
          queryKey: [{ filters }],
          queryFn: ({ queryKey: [_base, _detail, id] }) =>
            listOrganizationInvitations(id as string, filters),
        }),
        providers: {
          queryKey: null,
          queryFn: ({ queryKey: [_base, _detail, id] }) =>
            listOrganizationProviders(id as string),
        },
      },
    }),
    list: (filters: OrganizationFilters) => ({
      queryKey: [{ filters }],
      queryFn: () => listOrganizations(filters),
    }),
  },
);
